export const TRANSITION_READY_FOR_TEST = "41";
export const TRANSITION_PROD_DEPLOYMENT = "91";
